import React, { Component } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { has } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { updateLastViewedEssentialPage } from '../actions';

class WrappedPrivateRoute extends Component {
  constructor(props) {
    super(props);
    this.props.updateLastViewedEssentialPage(props.location.pathname);
  }
  render() {
    const { component, user, ...rest } = this.props;

    const resultComponent = (has(user, 'token') && user.token) ?
      component : () => (<Redirect to='/login' />);

    return (
      <Route
        {...rest}
        component={resultComponent}
      />
    );
  }
}

export const PrivateRoute = compose(
  withRouter,
  connect(
    ({ user }) => ({ user }),
    { updateLastViewedEssentialPage }
  ),
)(WrappedPrivateRoute);



// WEBPACK FOOTER //
// ./src/components/common/components.js